import app from 'app';
import templateUrl from './partners.html';
import './partners.scss';

import { logEvent, eventCategories } from 'helpers/analytics';

function Partners($document, $timeout, PartnersService) {
  const Partners = this;

  Partners.trackPartnerClick = function(partner) {
    if (partner.display.type !== 'state') {
      logEvent('partnerDetailPageViewed', {
        category: eventCategories.PARTNERS,
        sponsorCode: Partners.currentSponsorship.sponsor.sponsorCode,
        partnerName: partner.summary.title || partner.summary.subTitle,
        page: 'partnerPlan'
      });
    } else {
      logEvent('quickSearch', {
        category: eventCategories.CARE,
        specialty: partner.display.actions[0].params.specialtyId
      });
    }
  };

  Partners.$onInit = function() {
    PartnersService.getPartners(Partners.currentSponsorship.id).then(
      partners => {
        Partners.externalPartners = partners;
      }
    );
    if (Partners.scrollToPartners) {
      // We need the scroll to happen after rendering is complete, so
      // wrap in $timeout to force this to run after digest cycle
      $timeout(() => {
        const partnerElement = $document.find('#partners');
        $document.scrollToElement(partnerElement, 25);
      });
    }
  };
}

app.component('partners', {
  bindings: {
    currentUser: '<',
    currentSponsorship: '<',
    scrollToPartners: '<'
  },
  controller: Partners,
  controllerAs: 'Partners',
  templateUrl
});

export default 'partners';
